import { render, staticRenderFns } from "./train_rec.vue?vue&type=template&id=5292842a&scoped=true&"
import script from "./train_rec.vue?vue&type=script&lang=js&"
export * from "./train_rec.vue?vue&type=script&lang=js&"
import style0 from "./train_rec.vue?vue&type=style&index=0&id=5292842a&scoped=true&lang=less&"
import style1 from "./train_rec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5292842a",
  null
  
)

export default component.exports